module.exports = __webpack_public_path__ + "img/DSC_6580.a4538c76.jpg";